<template>
  <div class="ypo-breadcrumb" v-if="breadcrumbList && breadcrumbList.length">
    <v-breadcrumbs :items="breadcrumbList" divider=">">
      <template v-slot:item="{ item }">
        <v-breadcrumbs-item
            :href="item.href || '#'"
            :disabled="item.disabled"
        >
          {{ item.text }}
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>
  </div>
</template>

<script>

export default {
  name: "YpoBreadcrumb",
  props: {
    breadcrumbList: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss">
@import "../../common/styles/_colors.scss";
@import "../../common/styles/_responsive.scss";

.ypo-breadcrumb {
  .v-breadcrumbs {
    padding: 0;

    &__divider {
      color: $black !important;
    }

    &__item {
      color: $black !important;
      font-size: 12px;
      text-transform: capitalize;

      &:hover {
        text-decoration: underline;
      }
    }

    li:last-of-type {
      font-weight: 600;
      pointer-events: none;
    }
  }

  .theme--light.v-breadcrumbs .v-breadcrumbs__divider, .theme--light.v-breadcrumbs .v-breadcrumbs__item--disabled {
    color: $black !important;
  }
}
</style>
